import DocumentPage from "../../../../invoice/DocumentPage";
import { siiCorrectiveInvoiceConfig } from "./config";

const SIICorrectiveInvoice = () => (
  <DocumentPage config={siiCorrectiveInvoiceConfig} />
);

export default SIICorrectiveInvoice;
